export function sortKeys(obj) {
  let allKeys = Object.keys(obj)
  allKeys.sort()

  let objTemp = {}
  for (let key of allKeys) {
    objTemp[key] = obj[key]
  }
  return objTemp
}

export function setUserPreference(
  authToken,
  userLevel,
  userCity,
  username,
  id,
  subjectId
) {
  let localStorage = window.localStorage
  localStorage.setItem('auth_token', authToken)
  localStorage.setItem('user_level', userLevel)
  localStorage.setItem('user_city', userCity)
  localStorage.setItem('username', username)
  localStorage.setItem('id', id)
  localStorage.setItem('subject_id', subjectId)
}

export function getUserPreference() {
  let localStorage = window.localStorage
  return {
    authToken: localStorage.getItem('auth_token'),
    userLevel: localStorage.getItem('user_level'),
    userCity: localStorage.getItem('user_city'),
    username: localStorage.getItem('username')
  }
}
